import { track } from './analytics';

// Bridges /auth/callback (knows it is a new account) and ProtectedRoute (knows who the user is).
const PENDING_SOCIAL_SIGNUP = 'lili:pending-social-signup';

export function markSocialSignup(method: string) {
  try {
    sessionStorage.setItem(PENDING_SOCIAL_SIGNUP, method);
  } catch {
    // storage blocked — the signup just goes untracked
  }
}

export function trackPendingSocialSignup(user: { id: string; createdAt: Date | string }) {
  try {
    const method = sessionStorage.getItem(PENDING_SOCIAL_SIGNUP);
    if (!method) return;
    sessionStorage.removeItem(PENDING_SOCIAL_SIGNUP);
    track(
      'user_signed_up',
      { signup_method: method },
      { dedupe: { id: `su-${user.id}`, time: user.createdAt } }
    );
  } catch {
    // storage blocked — the signup just goes untracked
  }
}
